/* eslint-disable max-lines-per-function */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
import { useEffect, useRef, useState } from "react";
import ItemBody from "./previews-item-body";
import ItemHeader from "./previews-item-header";

import {
  getHeightPreview,
  getPositionPreview,
} from "../../../helpers/previewHelpers";

const PreviewsItem = ({
  previewKey,
  image,
  imageWidth,
  imageHeight,
  imageName,
  previewItem,
  previewPosition,
  previewCategory,
  dispatch,
  isCategoryShow,
  uploadElement,
  showPreviewEditPopup,
  selectPreview,
  showDescription,
  imageDownload,
  previewSelected,
  analytics,
  service
}) => {
  const itemElement = useRef(null);
  const [previewItemWidth, setPreviewItemWidth] = useState(359);
  const [showReadMore, setShowReadMore] = useState(false);

  useEffect(() => setShowReadMore(false), [previewCategory]);

  useEffect(() => {
    function handleResize() {
      if (isCategoryShow) setPreviewItemWidth(itemElement.current.clientWidth);
    }

    window.addEventListener("resize", handleResize);

    return window.removeEventListener("resize", handleResize);
  });

 
  let previewStyle = {};
  let customTop = 0;
  let customLeft = 0;
  let styleHeight = 0;

  if(isCategoryShow) {
    styleHeight = getHeightPreview(
      previewItem.width,
      previewItem.height,
      previewItemWidth
    );
  
    const previewItemPosition = [...previewPosition].filter(
      (itemPosition) =>
        itemPosition.category === previewCategory &&
        itemPosition.index === previewKey
    );

    const { left, top } = getPositionPreview(
      previewItemPosition.length ? previewItemPosition[0].top : 0,
      previewItemPosition.length ? previewItemPosition[0].left : 0,
      previewItem.height,
      previewItem.width,
      styleHeight,
      previewItemWidth,
    );
  
    previewStyle = 
       {
          height: `${styleHeight ? styleHeight : 150}px`,
          backgroundPositionX: `${left ? left + "px" : "50%"}`,
          backgroundPositionY: `${top ? top + "px" : "50%"}`,
        };

      if (previewItemPosition && previewItemPosition.length > 0) {
        const dataPosition = previewItemPosition[0];
        customTop = dataPosition.top;
        customLeft = dataPosition.left;
      }
  }


  const clickUpdateHandler = (previewKey, showPreviewEditPopup, dispatch) => {
    const previewUpdate = showPreviewEditPopup(previewKey);
    dispatch(previewUpdate.preview);
    dispatch(previewUpdate.popup);
  };

  const itemBodyClickUpdateHandler = (sendClickUpload, uploadElement) => {
    sendClickUpload("preview");
    uploadElement.current.click();
  }

  return (
    <li className="preview__item" ref={itemElement} key={previewKey}>
      <ItemHeader
        previewItem={previewItem}
        isVisible={true}
        showReadMore={showReadMore}
        showDescription={showDescription}
        setShowReadMore={setShowReadMore}
        service={service}
      />
      <ItemBody
        previewKey={previewKey}
        image={image}
        previewItem={previewItem}
        previewIsSelected={
          previewSelected.length && previewSelected.includes(previewKey)
        }
        isCategoryShow={isCategoryShow}
        selectPreview={selectPreview}
        previewSelected={previewSelected}
        uploadElement={uploadElement}
        styleHeight={styleHeight}
        previewStyle={previewStyle}
        imageDownload={imageDownload}
        imageName={imageName}
        imageWidth={imageWidth}
        imageHeight={imageHeight}
        positionX={customTop}
        positionY={customLeft}
        showPreviewEditPopup={showPreviewEditPopup}
        dispatch={dispatch}
        analytics={analytics}
        previewCategory={previewCategory}
        clickUpdateHandler={clickUpdateHandler}
        itemBodyClickUpdateHandler={itemBodyClickUpdateHandler}
      />
    </li>
  );
};

export default PreviewsItem;
